import { Anchor, Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent } from "@newsela/snitch";
import ChevronRightIcon from "@/icons/ChevronRightIcon";
import {
  assignmentAnchorCss,
  assignmentHeaderCss,
  assigneeCss,
  bylineCss,
  containerCss,
} from "./AssignmentAnchorItem.style";

const propTypes = {
  assignee: PropTypes.object,
  id: PropTypes.string,
  date: PropTypes.string,
  byline: PropTypes.string,
  href: PropTypes.string,
  title: PropTypes.string,
};

const AnchorWithTrackEvent = withTrackEvent(Anchor);

const AssignmentAnchorItem = ({ assignee, byline, date, href, title }) => {
  return (
    <>
      <AnchorWithTrackEvent
        __cssFor={{ root: assignmentAnchorCss }}
        href={href}
        icon={{
          SvgComponent: ChevronRightIcon,
          isIconBeforeText: false,
        }}
        styleAnchorAsButton={{
          size: Button.sizes.lg,
          isFullWidth: true,
          flavor: Button.flavors.secondary,
        }}
        actionName="Navigate"
        streamProperties={{
          description: "Navigate student work assignment",
        }}
      >
        <div css={containerCss}>
          <h4 css={assignmentHeaderCss}>{title}</h4>
          {byline && <p css={bylineCss}>{byline}</p>}
          <span>{date}</span>
          {assignee && <p css={assigneeCss}>{assignee}</p>}
        </div>
      </AnchorWithTrackEvent>
    </>
  );
};

AssignmentAnchorItem.propTypes = propTypes;
export default AssignmentAnchorItem;
